'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var VerticalScrollBar = require('../common/VerticalScrollBar');

var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');

var Border = require('../common/Border');
var textHelper = require('../../helper/util').Text;


var Item = React.createClass({
  render: function () {
    var css = {
      height: this.props.height,
      lineHeight: this.props.height + 'px',
      backgroundColor: this.props.backgroundColor || '#fff',
      borderLeftColor: this.props.hideLeftBorder ? this.props.backgroundColor : '#000',
      borderRightColor: this.props.hideRightBorder ? this.props.backgroundColor : '#000'
    };
    return (<div className="item" style={css} onClick={this._onSelfClick}>
      <label>{this.props.text}</label>
    </div>);
  },

  _onSelfClick: function (e) {
    if (this.props.onClick) {
      this.props.onClick(e, this.props.index);
    }
  }
});

var VerticalTabBar = React.createClass({

  propTypes: {
    text: React.PropTypes.string.isRequired
  },
  getInitialState: function () {
    return {
      selectedIndex: parseInt(this.props.selectedIndex, 10)
    };
  },

  parseText: function () {
    return textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
  },

  render: function () {
    var textItems = this.parseText();
    this.showScrollBar = false;
    var tabHeight = this.props.tabHeight;
    var value = 0;
    var isLeft = this.props.direction === appTypes.HorizontalDirection.LEFT;
    var selIndex = this.state.selectedIndex;

    var h = styleHelper.getHeight(this.props);
    var bg = styleHelper.getBackgroundColor(this.props);

    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
      this.showScrollBar = this.props.verticalScrollbarShow;
      value = parseInt(this.props.verticalScrollbarProgress, 10);
    }

    var style = {
      whiteSpace: 'nowrap',
      textAlign: 'center',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%'
    };
    styleHelper.builderTextStyle(this.props, style);

    return (<div className='component component-verticalTabBar'
                 style={style}>

      <div ref="content" className="content" style={this.contentCSS(isLeft)}>
        {
          this.showScrollBar && (<VerticalScrollBar ref="scroll" {...{
            value: value,
            right: 0,
            height: '100%',
            zIndex: 1
          }}/>)
        }
      </div>

      <div ref="bar"
           className="bar"
           style={{
            height: h - 20
      }}>
        {
          textItems.map(function (item, index) {
            return (<Item
              key={index}
              index={index}
              hideLeftBorder={!isLeft && (index === selIndex)}
              hideRightBorder={isLeft && (index === selIndex)}
              text={item}
              height={tabHeight}
              backgroundColor={index === selIndex ? bg : '#ddd'}
              onClick={this.onSelected.bind(this, index)}
            />);
          }, this)
        }
      </div>
    </div>)
  },

  componentDidMount: function () {
    this.adjustPoint();
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onSelected);
  },

  adjustPoint: function () {
    var bar = ReactDOM.findDOMNode(this.refs.bar);
    var content = ReactDOM.findDOMNode(this.refs.content);
    var scroll;
    var isLeft = this.props.direction === appTypes.HorizontalDirection.LEFT;
    var barWidth = bar.clientWidth;
    var items = bar.children;
    var item;
    var t = bar.offsetTop;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var i;
    if (this.showScrollBar) {
      scroll = ReactDOM.findDOMNode(this.refs.scroll);
    }
    $(content).css({width: w - barWidth});
    if (isLeft) {
      $(bar).css({left: 0, width: barWidth + 1});
      $(content).css({left: barWidth});
    } else {
      $(content).css({left: 0});
      $(bar).css({left: w - barWidth - 1});
    }
    if (scroll) {
      $(scroll).css({left: content.clientWidth - scroll.clientWidth - 1});
    }
    for (i = 0; i < items.length; i++) {
      item = items[i];
      if (item.offsetTop + item.clientHeight + t > h) {
        $(item).css({display: 'none'});
      }
    }
  },

  contentCSS: function (isLeft) {
    var showBorder = this.props.borderVisible;
    return {
      backgroundColor: styleHelper.getBackgroundColor(this.props),
      borderTopStyle: showBorder ? 'solid' : 'none',
      borderBottomStyle: showBorder ? 'solid' : 'none',
      borderLeftStyle: isLeft ? 'solid' : ( showBorder ? 'solid' : 'none'),
      borderRightStyle: !isLeft ? 'solid' : (showBorder ? 'solid' : 'none')
    }
  },

  onSelected: function (index) {
    this.setState({
      selectedIndex: index
    })
  }

});

module.exports = VerticalTabBar;



/** WEBPACK FOOTER **
 ** ./src/views/Components/VerticalTabBar.jsx
 **/